(function($) {

    $('#navbarPrimary').on('show.bs.collapse', function() {
        $('.site-header').addClass('active-xs');
    });

    $('#navbarPrimary').on('hidden.bs.collapse', function() {
        $('.site-header').removeClass('active-xs');
    });

}(jQuery));


// Get height of viewport
mobileNavHeight = function() {
    var primaryToggle = $('.navbar-primary .navbar-toggler');

    /*Adds height to parent collapse*/
    primaryToggle.on('click', function() {
        if (($(this).hasClass('collapsed')) && ($(window).width() <= 976)) {
            $('body').addClass('no-scroll');
        } else {
            $('body').removeClass('no-scroll');
        }
    });

    var primaryNavbarCollapse = $('.navbar-collapse.collapse .collapse-body');
    var primaryHeader = $('.navbar-header');
    var primaryHeaderHeight = $(window).height() - primaryHeader.outerHeight();

    if ($(window).width() <= 976) {
        primaryNavbarCollapse.css('height', primaryHeaderHeight);
    } else {
        primaryNavbarCollapse.css('height', 'auto');
    }

};
mobileNavHeight();

$(window).resize(function() {
    mobileNavHeight();
});
